export const SMS_STOP_OPT_OUT_TEXT = "Reply STOP to opt out.";

const STOP_WORD = /\bSTOP\b/i;
const STOP_OPT_OUT_SUFFIX = /\s*Reply STOP to opt out\.?\s*$/i;

export const mentionsStop = (body: string) => STOP_WORD.test(String(body || ""));

/** Append the STOP line when the body does not already mention STOP. */
export const withStopOptOut = (body: string) => {
  const text = body == null ? "" : String(body);
  const stripped = text.trimEnd();
  if (!stripped || mentionsStop(stripped)) return stripped;
  return `${stripped} ${SMS_STOP_OPT_OUT_TEXT}`;
};

/** Remove a trailing STOP opt-out line if present. */
export const withoutStopOptOut = (body: string) =>
  String(body || "").replace(STOP_OPT_OUT_SUFFIX, "").trimEnd();
